module.exports = __webpack_public_path__ + "img/fee.a0b8fd85.png";